import { StyleSheet } from "react-native";
export default StyleSheet.create({
  container: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: "#b2b2b2",
    backgroundColor: "#FFFFFF"
  },
  primary: {
    flexDirection: "row",
    alignItems: "flex-end"
  },
  accessory: {
    height: 44
  }
});